import _objectWithoutProperties from "/home/bamboo/bamboo-agent-home/xml-data/build-dir/DETOX-SHOP218-JOB1/node_modules/gatsby/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["title", "titleId"];

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import * as React from "react";

function Shop(_ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 16,
    height: props.size || 16,
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M11.67 1a6.014 6.014 0 015.987 5.52h.956c1.577 0 2.908 1.204 3.03 2.741l.901 11.376c.003 1.169-.898 2.055-2.006 2.055H3.01C1.901 22.692 1 21.806 1 20.716l.904-11.455c.122-1.537 1.453-2.741 3.03-2.741h.75A6.014 6.014 0 0111.67 1zm6.943 7.52H4.934c-.54 0-.996.396-1.036.899l-.893 11.268 17.533.005h.004L19.65 9.419c-.04-.503-.495-.899-1.036-.899zM11.67 3a4.012 4.012 0 00-3.976 3.52h7.953A4.012 4.012 0 0011.67 3z",
    fill: props.color || "#222",
    fillRule: "evenodd"
  }));
}

var MemoShop = React.memo(Shop);
export default MemoShop;